import React from 'react'

const easeIn = (t: number, alpha: number) => Math.pow(t, alpha)

const getMask = (height: number, opacity: number) => `
    linear-gradient(180deg, black, rgba(255, 255, 255, ${opacity})) center bottom/100%
        ${height}px no-repeat,
    linear-gradient(180deg, black, black) center top/100% calc(100% - ${height}px)
        no-repeat`

interface IScrollFadeProps {
  height?: number
}

const ScrollFade: React.FC<IScrollFadeProps> = ({ height = 100 }) => {
  const rootRef = React.useRef<HTMLDivElement>(null)

  const onScroll = React.useCallback(() => {
    const scrollElement = rootRef.current?.parentElement
    if (scrollElement) {
      const {
        offsetHeight: elementHeight,
        scrollHeight: elementWidth,
        scrollTop,
      } = scrollElement
      const opacity = easeIn(scrollTop / (elementHeight - elementWidth), 10)
      const mask = getMask(height, opacity)

      scrollElement.style.mask = mask
    }
  }, [])

  React.useEffect(() => {
    const scrollElement = rootRef.current?.parentElement

    if (scrollElement) {
      const { offsetHeight, scrollHeight } = scrollElement
      if (offsetHeight !== scrollHeight) {
        const mask = getMask(height, 0)
        scrollElement.style.mask = mask
      }

      scrollElement.addEventListener('scroll', onScroll)
      return () => scrollElement.removeEventListener('scroll', onScroll)
    }
  }, [])

  return <div className="scroll-fade" ref={rootRef} />
}

export default ScrollFade
